export default function decodeBase64(base64Encoded) {
  const a = window.atob(String(base64Encoded).replace(/[\t\n\f\r ]+/g, ""));
  const buffer = Uint8Array.from(a, (c) => c.charCodeAt(0));

  return buffer;
}
